import {calculateLuminance} from "@Header/functions/calculateLuminance";

export const isLightBackground = (pixelData: Uint8ClampedArray[]) => {
    // @ts-ignore
    const [r, g, b] = pixelData;
    // @ts-ignore
    return calculateLuminance(r, g, b) > 128
}
